var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFloorplan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8A8",
    d: "M17 14h5v6a2 2 0 0 1-2 2h-5v-6a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M12.184 2.75A2.25 2.25 0 0 0 9.934 5v9.247H5a2.25 2.25 0 0 0-2.25 2.25v3.438A2.25 2.25 0 0 0 5 22.185h15a2.25 2.25 0 0 0 2.25-2.25V5A2.25 2.25 0 0 0 20 2.75h-7.816z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.875 14.212L12.5 12.08M15.078 14.212h6.71M16.74 10.917v3.295"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFloorplan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/floorplan.d289d96b.svg";
export { ForwardRef as ReactComponent };